import React, { ReactFragment} from "react";
import axios from 'axios';
import { Button, Paper, Dialog, Grow, Slide, Radio, Box } from "@material-ui/core";
import { formatDate as dateFormatter, formatTime as timeFormatter, transition, tealiumDataLayerPush } from '../utility/utility';
import { bookSlot } from "../utility/apiService";
//assets
import { calendar,clock } from '../assets/img/index'

//global constant
// let currentPage = 0;

export function DisplaySlots({slotsData, classes, setSelectedSlot, setShowConfirmationPage, supplierInfo, uid, setShowAppointmentError, bookingType}){
    //#region constants
    const paperStyle = {borderRadius:'5px',width:'100%', 
    boxShadow:'2px 2px 12px 0 rgba(51, 51, 51, 0.15), -2px -2px 12px 0 rgba(51, 51, 51, 0.15)', margin:'auto'};
    const slots = slotsData['slots'].sort((i,j)=>{return +new Date(i.begin) - +new Date(j.begin)});
    const validUntil = slotsData['validUntil'];
    const initialData = slots.slice(0,5);
    const normalBG = 'rgba(192,192,192,0.3)';
    const Transition = transition('Slide');
    //#endregion

    //#region States
    const [displaySlots, setDisplaySlots] = React.useState(initialData);
    const [error, setError] = React.useState({error:false, type:null});
    const [appointment, setAppointment] = React.useState({});
    const [slideDirection, setSlideDirection] = React.useState('left');
    const [currentPage, setCurrentPage] = React.useState(0);
    //#endregion

    //#region utility functions

    //#region Confirm Slot
    const confirmSlot = () => {
        // if(new Date(validUntil) < new Date(appointment['begin'])) {
        //     setErrorType('validityError');
        //     return setError({error:true, type:null});
        // }
        if(Object.keys(appointment).length){
            bookSlot(uid,appointment['id'])
            .then((anypointResponse:Object)=>{
                if(anypointResponse['data'].hasOwnProperty('code') && anypointResponse['data']['code'] == 0 ){
                    if(bookingType===1){
                        tealiumDataLayerPush('pageview', {}, {}, {siteStructureElement:["technician scheduler","booking success"]}, {}).then();
                    }else if(bookingType===2){
                        tealiumDataLayerPush('pageview', {}, {}, {siteStructureElement:["technician rescheduler","booking success"]}, {}).then();
                    }
                    setSelectedSlot(appointment);
                    setCurrentPage(0);
                    return setShowConfirmationPage(true);
                } else {
                    if(bookingType===1){
                        tealiumDataLayerPush('error', {type:'technical',message:'backend error received',location:'landing page - scheduling'}, {}, {}, {}).then();
                    }else if(bookingType===2){
                        tealiumDataLayerPush('error', {type:'technical',message:'backend error received',location:'landing page - rescheduling'}, {}, {}, {}).then();
                    }
                    setSelectedSlot(appointment);
                    return setShowAppointmentError(true);
                }
            })
            .catch(anypointErrorResponse=>{
                if(bookingType===1){
                    tealiumDataLayerPush('error', {type:'technical',message:'backend error received',location:'landing page - scheduling'}, {}, {}, {}).then();
                }else if(bookingType===2){
                    tealiumDataLayerPush('error', {type:'technical',message:'backend error received',location:'landing page - rescheduling'}, {}, {}, {}).then();
                }
                return setShowAppointmentError(true);
            });
        } else {
            return setError({error:true, type:'invalidSlot'});
        }
    }
    //#endregion

    //#region close error Dialog
    const closeDialog = ()=> {
        setError({error:false, type:null});
        // if (errorType === 'validityError') {setError(false);reloadSlots()}
        // else {setError(false);}
    }
    //#endregion

    //#region Supplier Info Popup

    const Error = () => {

        let supplierError:ReactFragment = <>
        <p>Du brauchst einen anderen Termin? </p>
        <p>Du erreichst deinen zuständigen Vodafone Service Partner unter: {supplierInfo.sePhone}</p>
        <p>Bitte halte deine Auftragsnummer <strong>{supplierInfo.workOrderId}</strong> bereit.</p>
                </>

        let anypointError:ReactFragment = <>
            <p>Oops Something wrong happened</p>
        </>  

        let slotError:ReactFragment = <>
            <p>Slot not selected</p>
            <p>can't book unless a valid slot is selected</p>
        </>

        let validityError:ReactFragment = <>
            <p> Slots Expired !!!!</p>
            <p>Slots are valid only for 1 hour</p>
        </>
 
        return (
            <React.Fragment>
                <Dialog
                TransitionComponent={Transition}
                open={true}
                onClose={closeDialog}>
                    <div className={classes.padding10}>
                        {
                            error.type === 'anypoint' ? 
                            anypointError : 
                            error.type === 'invalidSlot' ?
                            slotError :
                            error.type === 'supplier' ?
                            supplierError : 
                            error.type === 'validityError' ?
                            validityError : 
                            null
                        }
                        <Button className={classes.button} variant='contained' size='medium' onClick={closeDialog}>OK</Button>
                    </div>
                </Dialog>
            </React.Fragment>
        )
    }
    //#endregion

    //#region  Next N slots
    const getNextN = (n:number) => {
        currentPage >= Math.floor(slots.length/n)-1 ? setError({error:true, type:'supplier'}) :setError({error:false, type:null});
        if(currentPage === 3) {
        tealiumDataLayerPush('layover',{},{ action: "show", name: "customer needs a later appointment slot"},{}, {}).then();
        }
        const nextNCurrentPage = currentPage >= Math.floor(slots.length/n)-1 ? Math.floor(slots.length/n)-1: currentPage+1;
        setCurrentPage(nextNCurrentPage)
        setSlideDirection('left');
        return setDisplaySlots(slots.slice(currentPage*n,(currentPage*n)+n));
    }
    //#endregion

    //#region  Prev N slots
    const getPrevN = (n:number) => {
        const prevNCurrentPage = currentPage <= 0? 0: currentPage-1;
        setCurrentPage(prevNCurrentPage);
        setSlideDirection('right');
        return setDisplaySlots(slots.slice(((currentPage+1)*n)-n,(currentPage+1)*n));
    }
    //#endregion
    
    //#region slot selection
    const select = (slot:any) => {
        setAppointment(slot);
    }
    //#endregion
 

    return(
        <div className={classes.swa_flexBoxColumn+' '+classes.margin0+' '+classes.width100}>
            {error.error?<Error/>:null}
            <Grow in={true} timeout={300}>
            <Paper elevation={5} variant={"outlined"} square style={paperStyle}>
                <div className={classes.padding10}>Folgende Termine stehen zur Auswahl:</div>
                {displaySlots.map((slot)=>{
                    return(                     
                    <Box display="flex"
                        flexDirection="row"
                        bgcolor={normalBG}
                        m={1} p={1}
                        key={slot.id}
                        style={{cursor:'pointer', borderRadius:'5px',
                        borderStyle:'solid',
                        borderWidth:'1px 5px 1px 0px',
                        borderColor:appointment['id'] === slot.id ? 'gray':'transparent',
                        transition:'border 300ms ease-in-out 0s, transform 300ms ease-out'}}
                        onClick={()=>select(slot)}
                        >
                        <Radio
                            checked={appointment['id'] === slot.id}
                            value={slot.id}
                            name="radio-button-demo"/>
                        <Slide in={true} direction={slideDirection=="left" ? "left" : "right"} timeout={500}>
                        <div className={classes.swa_flexBoxColumn} >
                            <div className={classes.flexBoxRow+ ' ' +classes.margin0+' '+classes.noBoxShadow}>
                                <img src={calendar} width="20" style={{margin:'0 10px'}}/>
                                <div className="">{dateFormatter(slot.begin)}</div>
                            </div>
                            <div className={classes.flexBoxRow+ ' ' +classes.margin0+' '+classes.noBoxShadow}>
                                <img src={clock} width="20" style={{margin:'0 10px'}}/>
                                <div className="">{timeFormatter(slot.begin, slot.end)}</div>
                            </div>
                        </div>
                        </Slide>
                    </Box>
                    )
                })
                }
                <div className={classes.flexBoxRow+' '+classes.noBoxShadow+' '+classes.justifyCenter}>
                    <Button className={classes.button} variant="contained" disabled={currentPage===0} onClick={()=>{getPrevN(5)}}>ZURÜCK</Button>
                    <Button disabled>{`Seite ${currentPage+1} von ${Math.floor(slots.length/5)}`}</Button>
                    <Button className={classes.button} variant="contained" onClick={()=>{getNextN(5)}}>WEITER</Button>
                </div>
            <Button variant="contained" size="large" 
            onClick={confirmSlot} 
            className={classes.button}
            disabled={!Object.keys(appointment).length}
            style={{left:'50%', transform:'translateX(-50%)', margin:'20px 0'}}
            >Termin verbindlich buchen</Button>
            </Paper>
            </Grow>
        </div>
    )
}
 
